import n from "../../../@babel/runtime/helpers/esm/classCallCheck2.mjs";
import o from "../../../@babel/runtime/helpers/esm/createClass2.mjs";
var a = /* @__PURE__ */ function() {
  function t() {
    n(this, t), this.maps = void 0, this.maps = /* @__PURE__ */ Object.create(null);
  }
  return o(t, [{
    key: "set",
    value: function(e, i) {
      this.maps[e] = i;
    }
  }, {
    key: "get",
    value: function(e) {
      return this.maps[e];
    }
  }]), t;
}();
export {
  a as default
};
//# sourceMappingURL=CacheMap.mjs.map
